import { useState } from 'react'
import { Button } from '@teach/ui'
import { useMe } from '@/features/auth/useMe'
import { useMessages, useUiLang } from '@/i18n'
import { countryName, useCountriesQuery } from '../countriesApi'
import { CountryPickerDialog } from './CountryPickerDialog'
import { messages } from './messages'

/**
 * Страна профиля (PRD #71, п.28). Она общая с веб-академией и решает способы и
 * валюту оплаты кредитов; выбор здесь меняет её и там. До выбора бэк берёт
 * страну из GeoIP при входе, ручной выбор это автоопределение выключает.
 */
export const CountryCard = () => {
  const m = useMessages(messages)
  const lang = useUiLang()
  const country = useMe().data?.country ?? null
  const [open, setOpen] = useState(false)
  // Название текущей страны тоже из справочника, поэтому он нужен и без окна,
  // когда страна задана. Справочник держится сутки — второй раз не едет.
  const { data: countries } = useCountriesQuery(undefined, { skip: !open && !country })
  const current = countries?.find((c) => c.code === country)
  // Справочник ещё едет — пока стоит код, а не пустое место
  const label = current ? countryName(current, lang) : (country ?? m.countryNotSelected)

  return (
    <div className="flex items-center justify-between gap-3 rounded-2xl bg-foreground/5 px-4 py-3 sm:gap-4 sm:px-6 sm:py-4">
      <div className="min-w-0">
        <p className="truncate text-base font-medium sm:text-lg">{m.country}</p>
        <p className="truncate text-sm text-muted-foreground">{label}</p>
      </div>
      <Button variant="secondary" onClick={() => setOpen(true)}>
        {m.change}
      </Button>
      <CountryPickerDialog open={open} onOpenChange={setOpen} current={country} />
    </div>
  )
}
